import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const BlogCard = ({ post, delay = 0 }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      data-testid="blog-card"
    >
      <Link to={`/blog/${post.id}`}>
        <Card className="h-full overflow-hidden group hover:shadow-soft-lg transition-all duration-300 border-warm-gray-200 hover:border-brand-maroon">
          {/* Image */}
          <div className="relative h-48 overflow-hidden bg-warm-gray-100">
            <img
              src={post.imageUrl}
              alt={`${post.title} - Cybersecurity services in KSA`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute top-4 left-4">
              <Badge className="bg-brand-maroon text-white">{post.category}</Badge>
            </div>
          </div>

          <CardHeader>
            <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-3">
              <span className="flex items-center space-x-1">
                <Calendar className="w-4 h-4" />
                <span>{formatDate(post.date)}</span>
              </span>
              <span className="flex items-center space-x-1">
                <Clock className="w-4 h-4" />
                <span>{post.readTime}</span>
              </span>
            </div>
            <CardTitle className="text-xl font-bold group-hover:text-brand-maroon transition-colors line-clamp-2">
              {post.title}
            </CardTitle>
            <CardDescription className="line-clamp-2">
              {post.excerpt}
            </CardDescription>
          </CardHeader>

          <CardContent>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">{post.author}</span>
              <span className="text-brand-maroon font-medium text-sm flex items-center group-hover:translate-x-1 transition-transform">
                Read more <ArrowRight className="ml-1 w-4 h-4" />
              </span>
            </div>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
};

export default BlogCard;